<template>
    <div>
        <b-card  class="text-center" title="Turnos Laborales">
        </b-card>
        <b-card class="text-left">
        <b-row>
            <b-col md="6">
                <br>
                 <label for="Numbreu">Nombre Turno</label>
                 <b-form-input v-model="nombreTurno"  type="text"  placeholder="Nombre Turno"></b-form-input>
            </b-col>
            <b-col md="3">
                <br>
                <label for="Hora">Hora Inicio</label>        
                <b-input-group>
                <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clock-o"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="time" required v-model="horaIni"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col md="3">
                <br>
                <label for="Hora">Hora Fin</label>        
                <b-input-group>
                <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clock-o"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="time" required v-model="horaFin"></b-form-input>
                </b-input-group>
            </b-col>
             <b-col md="3">
                <br>
                <b-button variant="success" @click="enviar" >Crear Turno</b-button>
            </b-col>
            
        </b-row>
        </b-card>
    </div>
</template>

<script>
import List from '@/components/modules/base/list.vue'
export default {
    name: 'turnslist', 
 data (){
        return{
        id: this.$route.params.id,
        nombreTurno:'',
        horaIni:'',
        horaFin:'',
        }
 },
 created: function(){
    this.traerdata()
 },
    methods:{
        traerdata(){
            this.$store.dispatch('controlaccesoturnseditar', this.id).then(Response=>{
                  this.nombreTurno = this.$store.getters.controlaccesoturns.name
                  this.horaIni = this.$store.getters.controlaccesoturns.h_start
                  this.horaFin = this.$store.getters.controlaccesoturns.h_end
                }) 
        },
        enviar(){
            if(this.id !='' && this.nombreTurno !='' && this.nombreTurno !='' && this.horaIni !='' && this.horaFin !=''){
                    let  array={'id':this.id,'name':this.nombreTurno,'id_school':1,'h_start':this.horaIni,'h_end':this.horaFin}
                   
                    this.$store.dispatch('controlaccesoturnsupdate',array).then(Response=>{  
                        this.$router.push('/controlacceso/turns')
                }) 
            }else{
                alert('Tienes Campos Vacios');
            }
             

    }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/modules/controlacceso/turnsedit.vue